import "./tableHead.css"

const TableHead = () => {
    return (
        <table className="table" >
            <thead>
                <tr>
                    <th>Name</th>
                    <th><img src={require("../../img/wood.png")} alt="wood" /></th>
                    <th><img src={require("../../img/clay.png")} alt="clay" /></th>
                    <th><img src={require("../../img/iron.png")} alt="iron" /></th>
                    <th><img src={require("../../img/crop.png")} alt="crop" /></th>
                    <th>Total</th>
                </tr>
            </thead>
            
        </table>
    )
}
export default TableHead